import React, { useState } from "react";
import {
  Typography,
  Card,
  TextField,
  Grid,
  Box,
  Container,
  Alert,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Link } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import "../../styles/auth-style.css";
import {
  createUserWithEmailAndPassword,
  sendEmailVerification,
} from "firebase/auth";
import Locale from "../../locales";
import { auth } from "../../firebase";
import { fetchFirebaseErrorMessage } from "../../shared/firebaseErrorMessage";
import { EMAIL_REGEX, PASSWORD_REGEX } from "../../constants/Regex";

const useStyles = makeStyles({
  signinCard: {
    padding: "10px",
    width: "350px",
  },
  link: {
    cursor: "pointer",
  },
});
const initFormValues = {
  email: "",
  password: "",
  confirmPassword: "",
};
const EmailSignUpPage = () => {
  const styles = useStyles();
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [formData, setFormData] = useState(initFormValues);
  const [isLoading, setIsLoading] = useState(false);

  const handleSingUp = async (e) => {
    try {
      setIsLoading(true);
      e.preventDefault();
      const { email, password, confirmPassword } = formData;
      if (email.length === 0 || password.length === 0) {
        const errMessage = Locale.t("fields_left_empty");
        setSuccessMessage("");
        setErrorMessage(errMessage);
      } else if (!email.match(EMAIL_REGEX)) {
        const errMessage = Locale.t("invalid_emailId");
        setSuccessMessage("");
        setErrorMessage(errMessage);
      } else if (!password.match(PASSWORD_REGEX)) {
        const errMessage = Locale.t("password_err_message");
        setSuccessMessage("");
        setErrorMessage(errMessage);
      } else if (password !== confirmPassword) {
        const errMessage = Locale.t(
          "password_and_confirmPassword_are_not_same",
        );
        setSuccessMessage("");
        setErrorMessage(errMessage);
      } else {
        setSuccessMessage("");
        setErrorMessage("");
        const userCred = await createUserWithEmailAndPassword(
          auth,
          email,
          password,
        );

        await sendEmailVerification(userCred.user);
        setSuccessMessage(
          Locale.t(
            "account_created_please_go_to_your_mail_and_verify_yourself_to_continue_with_the_site_login_from_SignInWindow",
          ),
        );

        setFormData(initFormValues);
      }
    } catch (error) {
      const errMessage = fetchFirebaseErrorMessage(error.message);
      setErrorMessage(errMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="landing-page-container">
      <div className="landing-heading-container">
        <Typography variant="h2" className={styles.headingText}>
          {Locale.t("blobit")}
        </Typography>
      </div>
      <div className="email-signin-container">
        <Card elevation={6} className={styles.signinCard}>
          <Container component="main" maxWidth="xs">
            <Box
              sx={{
                borderRadius: 8,
                marginTop: 4,
                marginBottom: 2,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}>
              <Typography component="h1" variant="h5">
                {Locale.t("sign_up")}
              </Typography>
              <Box
                component="form"
                onSubmit={handleSingUp}
                noValidate
                sx={{ mt: 1 }}>
                <TextField
                  margin="normal"
                  type="email"
                  required
                  fullWidth
                  id="email"
                  label={Locale.t("email_address")}
                  name="email"
                  autoFocus
                  value={formData.email}
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                />

                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label={Locale.t("password")}
                  type="password"
                  value={formData.password}
                  id="password"
                  onChange={(e) =>
                    setFormData({ ...formData, password: e.target.value })
                  }
                />

                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="confirmPassword"
                  label={Locale.t("confirm_password")}
                  type="password"
                  value={formData.confirmPassword}
                  id="confirmPassword"
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      confirmPassword: e.target.value,
                    })
                  }
                />

                <LoadingButton
                  type="submit"
                  fullWidth
                  loading={isLoading}
                  variant="contained"
                  sx={{ mt: 2, mb: 2 }}>
                  {Locale.t("submit")}
                </LoadingButton>

                {errorMessage !== "" && (
                  <Alert severity="error">{errorMessage}</Alert>
                )}
                {successMessage !== "" && (
                  <Alert severity="success">{successMessage}</Alert>
                )}
                <Grid container justifyContent="center" marginTop={2}>
                  <Grid item>
                    <Link to="/signin">
                      <Typography
                        className={styles.link}
                        color="primary"
                        variant="body2">
                        {Locale.t("already_have_an_account_?_sign_in")}
                      </Typography>
                    </Link>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Container>
        </Card>
      </div>
    </div>
  );
};

export default EmailSignUpPage;
